import moment from 'moment'
import settings from 'src/settings.json'

export function initTime() {
    $('time').each(function() {
        let node = $(this)
        let dt = node.attr('datetime')
        let format = node.attr('data-format')
        let from = (node.attr('data-time-from') === 'true')

        if (format === undefined) {
            format = settings.default_time_format
        }

        // datetime attribute is - if the date has a None value in the backend
        // in this case we just set the text and title to -
        let display_datetime = '-'
        let local_datetime = '-'
        if (dt != '-') {
            local_datetime = moment(dt).format(format)
            if (from) {
                // Display value from this datetime to now e.g 4 days ago
                display_datetime = moment(dt).fromNow()
            } else {
                display_datetime = local_datetime
            }
        }

        node.text(display_datetime)
        node.attr('title', local_datetime)
    })
}
